import type { Styles } from 'common/types';

export const styles: Styles = {
  editorWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    minHeight: '340px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    border: '1px solid',
    borderColor: 'divider',
    transition: 'border-color 0.2s',
    '&:hover': {
      borderColor: 'text.disabled',
    },
    '&:focus-within': {
      borderColor: 'primary.main',
    },
    '& .quill': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      position: 'relative',
      paddingBottom: '8px',
      overscrollBehavior: 'contain',
    },
    '& .ql-toolbar': {
      position: 'sticky',

      /**
       * The -50px value is used to offset the 50px padding-top defined in
       * the main content container (.content class in Layout.module.scss).
       * This ensures the sticky toolbar aligns with the very top of the
       * browser viewport instead of stopping at the padding boundary.
       */
      top: '-50px',

      zIndex: 10,
      width: 'calc(100% - 16px)',
      margin: '8px auto 0 auto',
      border: '1px solid',
      borderColor: 'divider',
      backgroundColor: 'rgba(248, 250, 252, 0.95)',
      backdropFilter: 'blur(8px)',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
      fontFamily: 'inherit',
    },
    '& .ql-container': {
      border: 'none',
      flexGrow: 1,
      fontSize: '14px',
      fontFamily: 'inherit',
      borderBottomLeftRadius: '12px',
      borderBottomRightRadius: '12px',
      cursor: 'text',
    },
    '& .ql-editor': {
      minHeight: '240px',
      padding: '24px 16px',
    },
    '& .ql-tooltip': {
      borderRadius: '8px',
      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
      border: '1px solid',
      borderColor: 'divider',
      zIndex: 100,
      backgroundColor: '#fff',
      boxSizing: 'border-box',
      wordWrap: 'break-word',
      whiteSpace: 'normal',
      maxWidth: 'calc(100% - 32px)',
      transform: 'translateX(4px)',
    },
    '&.disabled': {
      opacity: 0.6,
      pointerEvents: 'none',
      backgroundColor: '#f1f5f9',
    },
    '&.disabled .ql-toolbar, &.empty .ql-toolbar': {
      position: 'static',
    },
  },
};
